<form (ngSubmit)="onSubmit()" [formGroup]="checkoutLoginForm">
  <cx-form-required-legend />
  <div class="form-group">
    <label>
      <span class="label-content">
        {{ 'checkoutLogin.emailAddress.label' | cxTranslate }}
        <cx-form-required-asterisks />
      </span>
      <input
        required="true"
        type="email"
        name="email"
        class="form-control"
        formControlName="email"
        placeholder="{{
          'checkoutLogin.emailAddress.placeholder' | cxTranslate
        }}"
        [attr.aria-invalid]="
          checkoutLoginForm.get('email')?.touched &&
          checkoutLoginForm.get('email')?.invalid
        "
        [attr.aria-errormessage]="'emailError'"
      />

      <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
      <cx-form-errors
        *cxFeature="'formErrorsDescriptiveMessages'"
        id="emailError"
        [translationParams]="{
          label: 'checkoutLogin.emailAddress.label' | cxTranslate,
        }"
        [control]="checkoutLoginForm.get('email')"
      ></cx-form-errors>

      <cx-form-errors
        *cxFeature="'!formErrorsDescriptiveMessages'"
        [control]="checkoutLoginForm.get('email')"
      ></cx-form-errors>
    </label>
  </div>

  <div class="form-group">
    <label>
      <span class="label-content">
        {{ 'checkoutLogin.confirmEmail.label' | cxTranslate }}
        <cx-form-required-asterisks />
      </span>
      <input
        required="true"
        type="email"
        name="emailConfirmation"
        class="form-control"
        formControlName="emailConfirmation"
        placeholder="{{
          'checkoutLogin.confirmEmail.placeholder' | cxTranslate
        }}"
        [attr.aria-invalid]="
          checkoutLoginForm.get('emailConfirmation')?.touched &&
          checkoutLoginForm.get('emailConfirmation')?.invalid
        "
        [attr.aria-errormessage]="'emailConfirmationError'"
      />

      <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
      <cx-form-errors
        *cxFeature="'formErrorsDescriptiveMessages'"
        id="emailConfirmationError"
        [translationParams]="{
          label: 'checkoutLogin.confirmEmail.label' | cxTranslate,
        }"
        [control]="checkoutLoginForm.get('emailConfirmation')"
      ></cx-form-errors>

      <cx-form-errors
        *cxFeature="'!formErrorsDescriptiveMessages'"
        [control]="checkoutLoginForm.get('emailConfirmation')"
      ></cx-form-errors>
    </label>
  </div>

  <button type="submit" class="btn btn-block btn-primary">
    {{ 'checkoutLogin.continue' | cxTranslate }}
  </button>
</form>
